var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h3", [_c("plain-text-control", { attrs: { title: _vm.title } })], 1),
      _vm._v(" "),
      _c("text-area-row", {
        attrs: {
          title: _vm.resourceSourcePath + ".BusinessId",
          id: "businessid",
          rows: 1,
          hideCharsLeft: true,
          maxLength: 20,
          noResize: true,
          rules: _vm.businessIdRules
        },
        model: {
          value: _vm.item.businessId,
          callback: function($$v) {
            _vm.$set(_vm.item, "businessId", $$v)
          },
          expression: "item.businessId"
        }
      }),
      _vm._v(" "),
      _c("text-area-row", {
        attrs: {
          title: _vm.resourceSourcePath + ".RealEstateId",
          id: "realestateid",
          rows: 1,
          hideCharsLeft: true,
          maxLength: 20,
          noResize: true,
          rules: _vm.realEstateIdRules,
          required: _vm.isInvestmentReport
        },
        model: {
          value: _vm.item.realEstateId,
          callback: function($$v) {
            _vm.$set(_vm.item, "realEstateId", $$v)
          },
          expression: "item.realEstateId"
        }
      }),
      _vm._v(" "),
      _c("numeric-input-row", {
        attrs: {
          title: _vm.resourceSourcePath + ".ConstructionYear",
          id: "targetinfoconstructionyear",
          rows: 1,
          hideCharsLeft: true,
          rules: _vm.yearRules,
          required: _vm.isInvestmentReport,
          formatting: false
        },
        model: {
          value: _vm.item.constructionYear,
          callback: function($$v) {
            _vm.$set(_vm.item, "constructionYear", $$v)
          },
          expression: "item.constructionYear"
        }
      }),
      _vm._v(" "),
      !_vm.isInvestmentReport || _vm.isBudgetaryEstimate
        ? _c(
            "div",
            [
              _c("radio-button-row", {
                key: _vm.radioButtonValueChanged,
                attrs: { title: _vm.resourceSourcePath + ".IsOwn" },
                model: {
                  value: _vm.item.isOwn,
                  callback: function($$v) {
                    _vm.$set(_vm.item, "isOwn", $$v)
                  },
                  expression: "item.isOwn"
                }
              }),
              _vm._v(" "),
              !_vm.item.isOwn
                ? _c("text-area-row", {
                    attrs: {
                      title: _vm.resourceSourcePath + ".OwnershipExplanation",
                      id: "ownershipexplanation",
                      required: true,
                      maxLength: 500,
                      rows: 5
                    },
                    model: {
                      value: _vm.item.ownershipExplanation,
                      callback: function($$v) {
                        _vm.$set(_vm.item, "ownershipExplanation", $$v)
                      },
                      expression: "item.ownershipExplanation"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }